import AM from './1688.json'

// 淘宝类目
export const cTaobao = {
  title: '主题市场',
  row: [
    {
      icon: '',
      iconActive: '',
      column: [
        {
          name: '女装',
          name_ja: 'レディースファッション',
          url: 'https://huodong.taobao.com/wow/a/act/tao/dailyact/4634/wupr?wh_pid=dailyAct-257518'
        },
        {
          name: '内衣',
          name_ja: 'インナーウェア',
          url: 'https://s.taobao.com/search?q=内衣'
        },
        {
          name: '家居',
          name_ja: '日用品',
          url: 'https://s.taobao.com/search?q=家居'
        }
      ]
    },
    {
      icon: '',
      iconActive: '',
      column: [
        {
          name: '女鞋',
          name_ja: 'レディースシューズ',
          url: 'https://huodong.taobao.com/wow/a/act/tao/dailyact/2772/wupr?wh_pid=dailyAct-216657'
        },
        {
          name: '男鞋',
          name_ja: 'メンズシューズ',
          url: 'https://s.taobao.com/search?q=%E7%94%B7%E9%9E%8B&imgfile=&commend=all&ssid=s5-e&search_type=item&sourceId=tb.index&spm=a21bo.2017.201856-taobao-item.1&ie=utf8&initiative_id=tbindexz_20170306'
        },
        {
          name: '箱包',
          name_ja: 'バッグ',
          url: 'https://s.taobao.com/search?q=%E7%AE%B1%E5%8C%85&imgfile=&commend=all&ssid=s5-e&search_type=item&sourceId=tb.index&spm=a21bo.21814703.201856-taobao-item.1&ie=utf8&initiative_id=tbindexz_20170306'
        }
      ]
    },
    {
      icon: '',
      iconActive: '',
      column: [
        {
          name: '母婴',
          name_ja: 'ベビー・マタニティ',
          url: 'https://s.taobao.com/search?ie=utf8&initiative_id=staobaoz_20210219&stats_click=search_radio_all%3A1&js=1&imgfile=&q=%E6%AF%8D%E5%A9%B4&suggest=history_1&_input_charset=utf-8&wq=%E6%AF%8D%E5%A9%B4&suggest_query=%E6%AF%8D%E5%A9%B4&source=suggest'
        },
        {
          name: '童装',
          name_ja: 'キッズファッション',
          url: 'https://s.taobao.com/search?q=童装'
        },
        {
          name: '玩具',
          name_ja: 'おもちゃ',
          url: 'https://s.taobao.com/search?q=玩具'
        }
      ]
    },
    {
      icon: '',
      iconActive: '',
      column: [
        {
          name: '男装',
          name_ja: 'メンズファッション',
          url: 'https://s.taobao.com/search?q=男装'
        },
        {
          name: '运动户外',
          name_ja: 'スポーツアウトドア',
          url: 'https://s.taobao.com/search?q=运动户外'
        }
      ]
    },
    {
      icon: '',
      iconActive: '',
      column: [
        {
          name: '数码',
          name_ja: 'デジタル',
          url: 'https://s.taobao.com/search?q=数码'
        },
        {
          name: '生活电器',
          name_ja: '家電',
          url: 'https://s.taobao.com/search?q=生活电器'
        }
      ]
    },
    {
      icon: '',
      iconActive: '',
      column: [
        {
          name: '厨具',
          name_ja: 'キッチン用品',
          url: 'https://s.taobao.com/search?q=厨具'
        },
        {
          name: '收纳',
          name_ja: '収納用品',
          url: 'https://s.taobao.com/search?q=收纳'
        }
      ]
    },
    {
      icon: '',
      iconActive: '',
      column: [
        {
          name: '家纺',
          name_ja: '寝具',
          url: 'https://s.taobao.com/search?q=家纺'
        },
        {
          name: '家饰',
          name_ja: '家具、インテリア用品',
          url: 'https://s.taobao.com/search?q=家饰'
        }
      ]
    },
    {
      icon: '',
      iconActive: '',
      column: [
        {
          name: '文具',
          name_ja: '文房具',
          url: 'https://s.taobao.com/search?q=%E6%96%87%E5%85%B7&imgfile=&commend=all&ssid=s5-e&search_type=item&sourceId=tb.index&spm=a21bo.2017.201856-taobao-item.1&ie=utf8&initiative_id=tbindexz_20170306'
        },
        {
          name: '汽车用品',
          name_ja: '車用品',
          url: 'https://car.tmall.com/wow/car/act/carfp'
        }
      ]
    },
    {
      icon: '',
      iconActive: '',
      column: [
        {
          name: '手表',
          name_ja: '腕時計',
          url: 'https://s.taobao.com/search?q=手表'
        },
        {
          name: '眼镜',
          name_ja: '眼鏡',
          url: 'https://s.taobao.com/search?q=眼镜'
        },
        {
          name: '珠宝饰品',
          name_ja: 'ジュエリー',
          url: 'https://s.taobao.com/search?q=珠宝饰品'
        }
      ]
    }
  ]
}

// 天猫类目
export const cTmall = {
  title: '主题市场',
  row: [
    {
      icon: '',
      iconActive: '',
      column: [
        {
          name: '女装',
          name_ja: 'レディースファッション',
          url: 'https://nvzhuang.tmall.com/'
        },
        {
          name: '内衣',
          name_ja: 'インナーウェア',
          url: 'https://neiyi.tmall.com/'
        }
      ]
    },
    {
      icon: '',
      iconActive: '',
      column: [
        {
          name: '男装',
          name_ja: 'メンズファッション',
          url: 'https://nanzhuang.tmall.com/'
        },
        {
          name: '运动户外',
          name_ja: 'スポーツ・アウトドア',
          url: 'https://sports.tmall.com/'
        }
      ]
    },
    {
      icon: '',
      iconActive: '',
      column: [
        {
          name: '女鞋',
          name_ja: 'レディースシューズ',
          url: 'https://list.tmall.com/search_product.htm?q=%C5%AE%D0%AC&type=p&spm=a220m.1000858.a2227oh.d100&from=.list.pc_1_searchbutton'
        },
        {
          name: '男鞋',
          name_ja: 'メンズシューズ',
          url: 'https://list.tmall.com/search_product.htm?q=%C4%D0%D0%AC&type=p&vmarket=&spm=a221t.7059849.a2227oh.d100&from=nanxie..pc_1_searchbutton'
        },
        {
          name: '箱包',
          name_ja: 'バッグ',
          url: 'https://list.tmall.com/search_product.htm?q=%CF%E4%B0%FC&type=p&vmarket=&spm=875.7931836%2FB.a2227oh.d100&from=mallfp..pc_1_searchbutton'
        }
      ]
    },
    {
      icon: '',
      iconActive: '',
      column: [
        {
          name: '腕表',
          name_ja: '腕時計',
          url: 'https://list.tmall.com/search_product.htm?q=%CD%F3%B1%ED&type=p&vmarket=&spm=875.7931836%2FB.a2227oh.d100&from=mallfp..pc_1_searchbutton'
        },
        {
          name: '眼镜',
          name_ja: '眼鏡',
          url: 'https://list.tmall.com/search_product.htm?spm=3.7396704.20000007.22.7CvfAH&cat=50023064&abbucket=&sort=s&acm=tt-1141518-37007.1003.8.75994&aldid=75994&theme=469&from=sn_1_rightnav&pos=3&style=g&search_condition=7&active=1&abtest=&scm=1003.8.tt-1141518-37007.OTHER_1433561526080_75994#J_crumbs'
        },
        {
          name: '珠宝饰品',
          name_ja: 'ジュエリー',
          url: 'https://dai.tmall.com/'
        }
      ]
    },
    {
      icon: '',
      iconActive: '',
      column: [
        {
          name: '数码',
          name_ja: 'デジタル',
          url: 'https://list.tmall.com/search_product.htm?q=%CA%FD%C2%EB&type=p&vmarket=&spm=875.7931836%2FB.a2227oh.d100&from=mallfp..pc_1_searchbutton'
        },
        {
          name: '电脑办公',
          name_ja: 'パソコン',
          url: 'https://list.tmall.com/search_product.htm?q=%B5%E7%C4%D4%B0%EC%B9%AB&type=p&vmarket=&spm=875.7931836%2FB.a2227oh.d100&from=mallfp..pc_1_searchbutton'
        }
      ]
    },
    {
      icon: '',
      iconActive: '',
      column: [
        {
          name: '生活电器',
          name_ja: '家電',
          url: 'https://list.tmall.com/search_product.htm?q=%C9%FA%BB%EE%B5%E7%C6%F7&type=p&vmarket=&spm=875.7931836%2FB.a2227oh.d100&from=mallfp..pc_1_searchbutton'
        }
      ]
    },
    {
      icon: '',
      iconActive: '',
      column: [
        {
          name: '家具',
          name_ja: '家具',
          url: 'https://list.tmall.com/search_product.htm?q=%BC%D2%BE%DF&type=p&spm=a220m.1000858.a2227oh.d100&from=.list.pc_1_searchbutton'
        },
        {
          name: '灯具',
          name_ja: 'ライト・照明',
          url: 'https://list.tmall.com/search_product.htm?q=%B5%C6%BE%DF&type=p&spm=a220m.1000858.a2227oh.d100&from=.list.pc_1_searchbutton'
        },
        {
          name: '卫浴',
          name_ja: 'バス用品',
          url: 'https://list.tmall.com/search_product.htm?q=%CE%C0%D4%A1&type=p&spm=a220m.1000858.a2227oh.d100&from=.list.pc_1_searchbutton'
        }
      ]
    },
    {
      icon: '',
      iconActive: '',
      column: [
        {
          name: '汽车配件',
          name_ja: 'カーアクセサリー',
          url: 'http://list.tmall.com/search_product.htm?spm=875.7789098.20150017.3.pPRs0I&cat=56772006&abbucket=&style=g&acm=lb-zebra-17931-286935.1003.8.431510&search_condition=55&aldid=431510&industryCatId=50660004&active=1&uuid=75987&from=sn_1_rightnav&abtest=&scm=1003.8.lb-zebra-17931-286935.ITEM_1452718919037_431510&pos=11#J_crumbs'
        },
        {
          name: '汽车用品',
          name_ja: '車用品',
          url: 'http://list.tmall.com/search_product.htm?spm=875.7789098.20150017.3.P1jZNx&cat=56838011&abbucket=&style=g&acm=lb-zebra-17931-286935.1003.8.431510&search_condition=55&aldid=431510&industryCatId=50660004&active=1&uuid=75987&from=sn_1_rightnav&abtest=&scm=1003.8.lb-zebra-17931-286935.ITEM_1452718919037_431510&pos=11#J_crumbs'
        }
      ]
    },
    {
      icon: '',
      iconActive: '',
      column: [
        {
          name: '家纺',
          name_ja: '寝具',
          url: 'https://pages.tmall.com/wow/jz/act/jfwx?wh_biz=tm'
        },
        {
          name: '家饰',
          name_ja: '家具、インテリア用品',
          url: 'https://pages.tmall.com/wow/jz/act/jfwx?wh_biz=tm'
        }
      ]
    },
    {
      icon: '',
      iconActive: '',
      column: [
        {
          name: '厨具',
          name_ja: 'キッチン用品',
          url: 'https://list.tmall.com/search_product.htm?spm=a220m.1000858.0.0.v7yFGa&cat=50036640&sort=s&style=g&search_condition=23&from=sn_1_rightnav&active=1&industryCatId=50036640&smAreaId=330100&tmhkmain=0#J_crumbs'
        },
        {
          name: '收纳',
          name_ja: '収納用品',
          url: 'https://list.tmall.com/search_product.htm?spm=3.7396704.20000007.31.7CvfAH&abbucket=&cat=50071786&sort=s&acm=tt-1141518-37011.1003.8.75975&aldid=75975&from=sn_1_rightnav&pos=2&style=g&search_condition=7&industryCatId=50071816&active=1&abtest=&scm=1003.8.tt-1141518-37011.OTHER_1430923523450_75975#J_crumbs'
        },
        {
          name: '宠物',
          name_ja: 'ペット用品',
          url: 'https://list.tmall.com/search_product.htm?spm=3.7396704.20000007.32.7CvfAH&abbucket=&cat=50034368&sort=s&acm=tt-1141518-37011.1003.8.75975&aldid=75975&from=sn_1_rightnav&pos=3&style=g&search_condition=7&industryCatId=50043495&active=1&uuid=92196&abtest=&scm=1003.8.tt-1141518-37011.OTHER_1430552830067_75975#J_crumbs'
        }
      ]
    }
  ]
}

// 1688类目
export const c1688 = {
  title: '品类市场',
  row: AM
}
